import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import WhatIfHeaderPres from '../presentational/WhatIfHeaderPres';
import countryLookup from 'country-code-lookup';
import intl from 'react-intl-universal';
import { setPageType } from '../state/whatIfActions';

class WhatIfHeaderContainer extends React.Component {
  getResults = () => {
    const { results, pageType, detailIndex, setPageType } = this.props;

    let resultsToReturn = results.map((result, index) => {
      result.misc = {
        headerLabel: intl.get('whatif.headerLabels.travelScenario') + (results.length > 1 ? index + 1 : ''),
        headerText: countryLookup.byCountry(result.homeCountry).iso3 + ' - ' + countryLookup.byCountry(result.hostCountry).iso3,
      };

      return result;
    });

    if (pageType === 'compare') {
      resultsToReturn = resultsToReturn.filter(result => {
        return result.selected;
      });
    }
    if (pageType === 'detail') {
      if (detailIndex !== null) {
        resultsToReturn = [results[detailIndex]];
      } else {
        setPageType('list');
      }
    }
    return resultsToReturn;
  };

  onBack = () => {
    const { pageType, history, setPageType } = this.props;

    if (pageType === 'list') {
      history.goBack();
    } else {
      setPageType('list');
    }
  };

  render() {
    return <WhatIfHeaderPres {...this.props} onBack={this.onBack} results={this.getResults()} />;
  }
}

const mapStateToProps = state => ({
  results: state.whatIf.results,
  pageType: state.whatIf.pageType,
  detailIndex: state.whatIf.detailIndex,
});

const mapDispatchToProps = {
  push,
  setPageType,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfHeaderContainer);
